
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ReceiptGrid extends Serenity.EntityGrid<ReceiptRow, any> {
        protected getColumnsKey() { return 'ECommerce.Receipt'; }
        protected getDialogType() { return ReceiptDialog; }
        protected getIdProperty() { return ReceiptRow.idProperty; }
        protected getInsertPermission() { return ReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptRow.localTextPrefix; }
        protected getService() { return ReceiptService.baseUrl; }


        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var dt = now.getDay();
            var mt = now.getMonth();
            var date = now.getDate();
            var cyr = now.getFullYear();
            var yr = now.getUTCFullYear();
            var hr = now.getUTCHours();
            var mn = now.getUTCMinutes();
            var sc = now.getUTCSeconds();

            var voucherNo = FormatHelper.GetVoucherNo(59);

            this.editItem(<ReceiptRow>{
                VoucherNo: voucherNo,
                VoucherTypeId:59,

            });
        }
    }
}